<template>
<div class="aaSignupResult">
    <div class="box">
        <div class="result">
            <div class="success">
                <div class="title">
                    <van-icon name="checked" />
                    <span class="name">签到完成</span>
                </div>
                <div class="tip">{{data.result ? data.result : '请按秩序入场'}}</div>
            </div>
        </div>
        <div class="ticket-activity">
            <div class="activity-detail">
                <div class="title texts-ellipse">{{data.title}}</div>
                <div class="datatime">{{data.begintime}} - {{data.endtime}}</div>
                <div class="addr text-ellipse">{{data.address}}</div>
            </div>
            <img :src="dividingLine" alt="" class="dividing-line">
            <div class="ticket-detail">
                <div class="ticketItem" v-for="(item, index) in data.ticketNumList" :key="index">
                    <div class="line" v-if="index !== 0"></div>
                    <div class="nameBox">
                        <div class="ticketName">{{item.ticketname}}</div>
                    </div>
                    <div class="participant">
                        <div class="left">参加人</div>
                        <div class="right">
                            <div class="textItem" v-for="(obj, i) in item.joinnamelist" :key="i">
                                <p class="name">{{obj.joinername}}</p>
                                <p class="phoneNum">{{obj.joinermobile}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="ticketNum">
                        <div class="left">票号</div>
                        <div class="right">
                            <div class="item" v-for="(obj, i) in item.ticketnolist" :key="i">
                                <p>{{obj.ticketno}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="statusBox">
                        <p>状态</p>
                        <p :class="{'status1': data.status === 1, 'status2': data.status === 2}">{{item.ticketstatusname}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="paymentResult-btn">
            <div class="btn my-ticket" @click="gotoSignup" v-if="data.result">重新签到</div>
            <div class="btn activity-detail" @click="gotoActivity">查看活动详情</div>
        </div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {apply, _setClass} from 'api/enumCode'
export default {
    name: 'aaSignupResult',
    data() {
        return {
            param: {
                eventid: this.$route.query.eventid ? this.$route.query.eventid : '',
                ticketid: this.$route.query.ticketid ? this.$route.query.ticketid : ''
            },
            // item: {
            //     eventinfo: {
            //         address: '',
            //         begintime: '',
            //         coveratturlid: '',
            //         endtime: '',
            //         eventid: '',
            //         title: ''
            //     },
            //     ticketinfo: {
            //         status: null,
            //         statusname: '',
            //         ticketname: '',
            //         ticketnum: 0,
            //         totalticketcount: 0,
            //         uprice: ''
            //     }
            // },
            init: false,
            dividingLine: require('@/common/images/activeTools/dividing_line@2x.png')
        }
    },
    props: ['data'],
    mounted() {
    },
    activated() {
    },
    methods: {
        gotoSignup() {
            this.$emit('anewSignup')
        },
        gotoActivity() {
            this.$router.push({name: 'ActivityDetail', query: {eventid: this.$route.query.eventid}})
        },
        ...mapActions([
            'setIsInit'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        cls () {
            return function(value) {
                return _setClass(value, apply.statusstatus)
            }
        },
        ...mapGetters([
            'isInit'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.aaSignupResult {
    background: $c-global;
    position: fixed;
    top: 0;
    left: 0;
    bottom:0;
    right:0;
    z-index: 10;
    overflow-y: auto;
    .box{
        background: #F5F7FA;
    }
    .result{
        font-size: 0.36rem;
        padding: 1rem 0 0.8rem 0;
        text-align: center;
        .title{
            display: flex;
            align-items: center;
            justify-content: center;
            .name{
                font-weight: 600;
                color:  #333333 ;
            }
            .van-icon{
                font-size: 0.5rem;
                margin-right: 0.18rem;
            }
        }
        .tip{
            color: #666666;
            font-size: 0.24rem;
            margin-top: 0.4rem;
        }
        .success{
            .van-icon{
                color: #0ABF53;
            }
        }
        .fail{
            .van-icon{
                color: #FF4747;
            }
        }
    }
    .ticket-activity{
        margin: 0 0.6rem;
        .activity-detail{
            box-shadow:0px 2px 6px 0px rgba(0,0,0,0.1);
            padding: 0.4rem 0.28rem 0.32rem 0.18rem;
            background: #fff;
            border-radius: 0.1rem 0.1rem 0 0;
            .title{
                font-size: 0.28rem;
                line-height: 0.32rem;
                color: #303133;
                margin-bottom: 0.2rem;
                font-weight: 600;
            }
            .datatime,.addr{
                color:  #666666;
                font-size: 0.24rem;
                line-height: 0.28rem;
                margin-top: 0.12rem;
            }
        }
        .dividing-line{
            width: 6.3rem;
            height: 0.28rem;
            display: block;
        }
        .ticket-detail{
            box-shadow:0px 2px 6px 0px rgba(0,0,0,0.1);
            padding: 0rem 0.28rem 0.6rem 0.28rem;
            background: #fff;
            border-radius: 0 0 0.1rem 0.1rem;
            .ticket-summary{
                color: #333333;
                font-size: 0.3rem;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                .value{
                    .num{
                        font-size: 0.2rem;
                        color: #999999;
                        margin-right: 0.32rem;
                    }
                    .item{
                        margin-bottom: 0.1rem;
                    }
                    .subtotal{
                    }
                }
            }
            .ticketItem{
                .line{
                    border-bottom: 0.02rem dashed #999999;
                    padding: 0.4rem 0 0.2rem;
                }
                .nameBox{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 0.2rem;
                    padding-bottom: 0.4rem;
                    .ticketName{
                        font-size: 0.28rem;
                        line-height: 0.4rem;
                        font-weight: 500;
                    }
                    .price{
                        display: flex;
                        align-items: center;
                        .ticketType{
                            color: #999999;
                            font-size: 0.2rem;
                            margin-right: 0.32rem;
                        }
                        .priceText{
                            font-size: 0.28rem;
                            color: #333333;
                        }
                    }
                }
                .participant, .ticketNum{
                    display: flex;
                    justify-content: space-between;
                    color: #666666;
                    padding-bottom: 0.4rem;
                    font-size: 0.28rem;
                    .left{
                        line-height: 0.4rem;
                    }
                    .right{
                        .textItem, .item{
                            display: flex;
                            justify-content: space-between;
                            p{
                                line-height: 0.4rem;
                            }
                            .name{
                                margin-right: 0.5rem;
                            }
                        }
                    }
                }
                .statusBox{
                    display: flex;
                    justify-content: space-between;
                    color: #666666;
                    font-size: 0.28rem;
                    .status1{
                        color: #0ABF53;
                    }
                    .status2{
                        color: #FF4747;
                    }
                }
            }
        }
    }
    .paymentResult-btn{
        margin:0.9rem 0.6rem 0 0.6rem;
        font-size: 0.3rem;
        padding-bottom: 0.32rem;
        .btn{
            height: 0.76rem;
            width: 6.3rem;
            text-align: center;
            line-height: 0.76rem;
            border-radius:0.4rem;
            box-sizing: border-box;
        }
        .my-ticket{
            color: #fff;
            background:linear-gradient(360deg,rgba(10,191,83,1) 0%,rgba(71,236,201,1) 100%);
        }
        .activity-detail{
            margin-top: 0.32rem;
            border: 1px solid #E5E5E5;
            background: #fff;
        }
    }
    .tc-orange{
        color: #FFA904;
    }
    .tc-red{
        color: #FF4747 ;
    }
    .tc-green{
        color: #0ABF53;
    }
}
</style>
